module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-6-en-CA-e99c48562ba90d067e3e1826b47b84bf.png";